require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crime-reporting-in-oregon.json") })
        }
      }, "path---crime-reporting-in-oregon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crime-reporting-in-oregon!./.cache/json/crime-reporting-in-oregon.json
// module id = 867
// module chunks = 231608221292675